<template>
  <div class="collectTopBar">
    <div class="collectTopBar-content">
      <div class="collectTopBar-content-img DT" :class="imgBgUrl"></div>
      <div class="collectTopBar-content-info">
        <p class="pot">我定制了一款{{dataList.dishName}}口味，</p>
        <p>命名为：</p>
        <p class="newName">“{{dataList.potName}}！”</p>
        <div class="info-bottom">
          <div class="info-bottom-logo"></div>
          <div class="info-bottom-info">
            <span class="iconfont icon-tanhao" style="margin-right: .1rem"></span>
            <span>了解海底捞</span>
            <span style="color: #e60012;" @click="goToIntroduce">[私人定制]</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ajax from '../../../pub/utils/ajaxUtils.js';
  import {getPrivatePot} from './../config/api.js';
  import mainUtils from '../../../pub/utils/mainUtils';

  export default {
    name: "headBar",
    data() {
      return {
        dishDetailId: '',
        dataList: {},
        dishListDetailId: '',// 菜品明细id
        privateCustomId: '',// 主键id
        imgBgUrl: '',
      }
    },
    methods: {
      // 详情
      getPrivatePot() {
        let params = {
          dishDetailId: this.dishDetailId,
          privateCustomId: this.privateCustomId,
        };
        ajax.postJson(getPrivatePot, params,
          data => {
            if (data.result === 200) {
              this.dataList = data.obj;
              if (this.dataList.dishName.includes('火锅')) {
                this.dataList.dishName = this.dataList.dishName.replace('火锅',"");
              }
              // 保存参数 提交时获取使用
              let _session = {
                dishListDetailId: this.dataList.dishListDetailId,
                potName: this.dataList.potName,
                privateCustomId: this.privateCustomId,
                shopId: this.dataList.shopId
              };
              sessionStorage.setItem('c', JSON.stringify(_session));
            }
          }
        );
      },
      // 私人订制介绍页面
      goToIntroduce() {
        this.$router.push({path: '/introduce'});
      },
    },
    created() {
      let pathName = mainUtils.pathName();
      for (let i in pathName) {
        this[i] = pathName[i];
      }
      this.getPrivatePot();
    },
  }
</script>
<style type="text/stylus" lang="stylus" scoped>
  @import '../../../assets/css/func.styl'
  @import './../share-bg.styl'
  .collectTopBar
    position relative
    z-index: 0
    box-sizing: border-box
    padding: .4rem .42rem 0
    .collectTopBar-content
      width: 6.66rem
      height: 10.2rem
      border-radius: 0.2rem
      box-shadow: 0 .02rem .6rem #e5e5e5;
    .collectTopBar-content-img
      height: 6.66rem
      border-top-left-radius: 0.2rem
      border-top-right-radius: 0.2rem
    .collectTopBar-content-info
      padding-left: .28rem
      padding-right: .3rem
      line-height .3rem
      font-size: .3rem
      color: #3f3f3f
      .pot
        margin-top .3rem
        margin-bottom .26rem
      .newName
        margin-top .34rem
        margin-bottom .84rem
        line-height .36rem
        font-size .36rem
        font-weight: 900
      .info-bottom
        display flex
        justify-content: space-between
        line-height: .36rem
        font-size .24rem
        .info-bottom-logo
          width: 1.22rem
          height: .36rem
          bg('../images/logo_hdl')
        .info-bottom-info
          display flex
          color: #8b8b8b
</style>


// WEBPACK FOOTER //
// src/components/share/collect/collectTopBar.vue